"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _semanticUiReact = require("semantic-ui-react");
function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
      result;
    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
var Map = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Map, _React$Component);
  var _super = _createSuper(Map);
  function Map() {
    (0, _classCallCheck2["default"])(this, Map);
    return _super.apply(this, arguments);
  }
  (0, _createClass2["default"])(Map, [{
    key: "getFormattedAddress",
    value: function getFormattedAddress() {
      var _this$createAddressCo = this.createAddressComponents(),
        street = _this$createAddressCo.street,
        locality = _this$createAddressCo.locality,
        country = _this$createAddressCo.country;
      return "".concat(street, ", ").concat(locality);
    }
  }, {
    key: "createAddressComponents",
    value: function createAddressComponents() {
      var address = this.props.address;
      var street = address.street,
        city = address.city,
        state = address.state,
        zip = address.zip,
        country = address.country;
      var locality = "".concat(city, ", ").concat(state, " ").concat(zip);
      return {
        street: street,
        locality: locality,
        country: country
      };
    }
  }, {
    key: "createMapLink",
    value: function createMapLink() {
      var businessName = this.props.businessName;
      var formattedAddress = this.getFormattedAddress(); // Link constants

      var embedBase = "https://www.google.com/maps/embed/v1/place?key=AIzaSyDqUbL6YR1jOLCK_edkm4f7lsLfcWzTVDA&q="; // Address query

      var query = encodeURIComponent(businessName ? "".concat(businessName, " ").concat(formattedAddress) : formattedAddress);
      return "".concat(embedBase).concat(query);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Embed, {
        url: this.createMapLink(),
        active: true
      });
    }
  }]);
  return Map;
}(_react["default"].Component);
exports["default"] = Map;
Map.propTypes = {
  address: _propTypes["default"].shape({
    city: _propTypes["default"].string.isRequired,
    state: _propTypes["default"].string.isRequired,
    zip: _propTypes["default"].string.isRequired,
    country: _propTypes["default"].string,
    street: _propTypes["default"].string
  }).isRequired,
  businessName: _propTypes["default"].string
};
Map.defaultProps = {
  businessName: ''
};